/**
 * Was ein Zählwerk **in diesem Messkonzept** zählt (HM-090).
 *
 * Die Rolle eines Zählwerks sagt „Bezug" oder „Einspeisung" — aus Sicht des
 * Netzes. An einem Wohnungszähler ist der Bezug ihr Verbrauch, an einem
 * PV-Zähler ist die Einspeisung die Erzeugung, an der Eigen-Wohnung die
 * Abgabe ins Haus. Das richtige Wort kennt die Vorlage (`meaning` am
 * Eingang), und der Eingang ist über den Knoten des Konzepts mit der
 * Messstelle verbunden. Ohne Konzept oder ohne Eingang gilt die Rolle —
 * ein Wort zu raten wäre die falschere Auskunft (Regel 9).
 */
import type { ApiComponents } from "@hausmeter/sdk";
import { registerRoleLabel } from "./meter-labels.js";
import { useConceptTemplate, useSiteConcepts } from "./queries.js";

type Concept = ApiComponents["schemas"]["MeasurementConcept"];
type Template = ApiComponents["schemas"]["ConceptTemplate"];
type Role = ApiComponents["schemas"]["MeterRegister"]["role"];

export function registerLabelInConcept(
  role: Role,
  meteringPointId: string,
  concept: Concept | null | undefined,
  template: Template | null | undefined,
): string {
  const node = concept?.nodes.find(
    (entry) => entry.type === "meter_register" && entry.meteringPointId === meteringPointId && entry.registerRole === role,
  );
  const input = node === undefined ? undefined : template?.inputs.find((entry) => entry.key === node.key);
  return input?.meaning ?? registerRoleLabel(role);
}

/** Der Beschrifter für die Zähler einer Anlage — lädt das aktive Konzept samt Vorlage einmal. */
export function useRegisterLabeler(siteId: string | null): (role: Role, meteringPointId: string) => string {
  const concepts = useSiteConcepts(siteId);
  const active = concepts.data?.concepts.find((concept) => concept.status === "active") ?? null;
  const template = useConceptTemplate(active?.id ?? null);
  return (role, meteringPointId) => registerLabelInConcept(role, meteringPointId, active, template.data ?? null);
}
